import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=cc8a6d8a&scoped=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=js&"
export * from "./ArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&id=cc8a6d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8a6d8a",
  null
  
)

export default component.exports